import React, { Component } from 'react';
import {
  Cascader,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
} from 'antd';
import moment from 'moment';
import {
  queryMaterialDatabaseList,
  queryMaterialDatabaseType,
  queryMaterialDirectoryList,
} from '@api/administrative/material';
import { queryDeleteAttachment, queryFilePreview } from '@api/pub/attachment';
import CompanySearch from '@comm/companySearch';
import UploadFile from '@comm/upload/UploadFileTable';
import { queryOrgCompanyList } from '@api/core/org';

const FormItem = Form.Item;

class ModalAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      returnEffect: [],
      databaseList: [],
      companyUuid: '',
    };
  }

  componentDidMount() {
    const { effect, incubator } = this.props;
    const { returnEffect } = this.state;
    effect &&
      effect.map(item => {
        item.delFiles = [];
        returnEffect.push(item);
        return 1;
      });
    this.setState({ returnEffect }, () => {
      this.getDatabaseList();
    });

    // 设置公司默认值
    queryOrgCompanyList({
      condition: incubator || '',
    }).then(res => {
      if (res.statusCode === 200 && res.data.length > 0) {
        const companyUuid = res.data[0].uuid;
        const company = res.data[0].name;
        this.setState({
          companyUuid,
          company,
        });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const { effect } = nextProps;
    const { returnEffect } = this.state;
    if (effect.length !== this.props.effect.length) {
      effect &&
        effect.map(item => {
          item.delFiles = [];
          returnEffect.push(item);
          return 1;
        });
      this.setState({ returnEffect });
    }
  }

  // 资料库列表
  getDatabaseList = () => {
    const { returnEffect } = this.state;
    queryMaterialDatabaseList().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          databaseList: res.data || [],
        });
        if (res.data && res.data.length > 0) {
          // 设置默认类型列表
          queryMaterialDatabaseType({
            databaseUuid: res.data[0].uuid,
          }).then(result => {
            if (result.statusCode === 200) {
              returnEffect.map(item => {
                item.types = result.data;
                return item;
              });
            } else {
              message.error(result.message, 2.5);
            }
          });

          // 设置默认目录列表
          queryMaterialDirectoryList({
            databaseUuid: res.data[0].uuid,
          }).then(result => {
            if (result.statusCode === 200) {
              this.formatList(result.data);
              returnEffect.map(item => {
                item.directoryList = result.data;
                item.directory = result.data[0].name;
                item.directoryUuid = result.data[0].uuid;
                return item;
              });
            } else {
              message.error(result.message, 2.5);
            }
          });
        }
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  handleDatabaseChange = (item, value) => {
    item.databaseUuid = value;
    this.getDirectoryList(item.databaseUuid);
    this.getDatabaseType(item.databaseUuid);
    this.props.form.resetFields([`directoryUuid${item.uuid}`, `materialType${item.uuid}`]);
  };

  // 资料目录列表
  getDirectoryList = uuid => {
    const { returnEffect } = this.state;
    queryMaterialDirectoryList({
      databaseUuid: uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        returnEffect.map(item => {
          if (item.databaseUuid === uuid) {
            this.formatList(res.data);
            item.directoryList = res.data;
          }
          return item;
        });
        this.setState({ returnEffect });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 获取资料类型
  getDatabaseType = uuid => {
    const { returnEffect } = this.state;
    queryMaterialDatabaseType({
      databaseUuid: uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        returnEffect.map(item => {
          if (item.databaseUuid === uuid) {
            item.types = res.data;
          }
          return item;
        });
        this.setState({ returnEffect });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  formatList = arr => {
    arr.map(item => {
      item.label = item.name;
      item.value = item.uuid;
      item.children && this.formatList(item.children);
      return item;
    });
  };

  handleOk = () => {
    const { returnEffect, databaseList } = this.state;
    const params = [];
    this.props.form.validateFields((err, values) => {
      if (!err) {
        returnEffect.map(item => {
          const it = { ...item };
          it.fileUuid = it.uuid;
          if (it.scan) {
            it.no = values[`no${item.uuid}`];
            it.databaseUuid = values[`databaseUuid${item.uuid}`];
            databaseList.map(i => {
              if (i.uuid === it.databaseUuid) {
                it.databaseName = i.name;
              }
              return i;
            });
            it.directoryUuid = item.directoryUuid;
            it.directory = item.directory;
            it.materialType = values[`materialType${item.uuid}`];
            it.returnDate = values[`returnDate${item.uuid}`].format('YYYY-MM-DD');
            it.companyUuid = values[`companyUuid${item.uuid}`];
            it.company = values[`company${item.uuid}`];
            it.returnCount = values[`returnCount${item.uuid}`];
          }
          it.scan =
            values[`scan${item.uuid}`] && values[`scan${item.uuid}`].length > 0
              ? values[`scan${item.uuid}`][0]
              : null;
          if (it.delFiles.length > 0) {
            it.delFiles.map(i => {
              queryDeleteAttachment({
                uuid: i.uuid || i.uid,
              }).then(() => {});
              return i;
            });
          }
          params.push(it);
          return item;
        });
        this.props.handleOk(params);
      }
    });
  };

  onChange = (uuid, value, selectedOptions) => {
    const { returnEffect } = this.state;
    returnEffect.map(item => {
      if (item.uuid === uuid) {
        item.directoryUuid = selectedOptions[selectedOptions.length - 1].uuid;
        item.directory = selectedOptions[selectedOptions.length - 1].name;
      }
      return item;
    });
    this.setState({ returnEffect });
  };

  showLable = label => {
    const text = label[label.length - 1];
    return text;
  };

  handleCompanyChange = (uuid, value, option) => {
    this.props.form.setFieldsValue({
      [`company${uuid}`]: option ? option.props.children : '',
    });
  };

  onUploadFileChange = (item, file) => {
    if (file.length > 0) {
      item.scan = file[0];
    } else {
      item.scan = null;
    }
  };

  /**
   *文件删除
   */
  fileRemove = (item, file) => {
    item.delFiles.push(file);
  };

  effectItem = item => {
    const { getFieldDecorator } = this.props.form;
    const { databaseList, companyUuid, company } = this.state;
    getFieldDecorator(`company${item.uuid}`, { initialValue: company });

    // 获取归属资料库
    const itemDatabaseUuid = this.props.form.getFieldValue(`databaseUuid${item.uuid}`);

    let defaultTypeName;

    // 如果归属资料库是总库（资料库第一个）
    if (databaseList.length > 0 && itemDatabaseUuid === databaseList[0].uuid) {
      // 设置默认类型
      defaultTypeName = '其他资料';
    }
    return (
      <div>
        <Row>
          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem>
              <div key={item.url}>
                <a onClick={() => queryFilePreview(item)}> {item.name}</a>
              </div>
            </FormItem>
          </Col>
          <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`no${item.uuid}`)(<Input placeholder="请填写文件编号" />)}
            </FormItem>
          </Col>
          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`databaseUuid${item.uuid}`, {
                rules: [
                  {
                    required: !!item.scan,
                    message: '请填写资料库',
                  },
                ],
                initialValue: item.scan && databaseList[0] ? databaseList[0].uuid : null,
              })(
                <Select
                  onChange={value => this.handleDatabaseChange(item, value)}
                  style={{ width: '100%' }}
                  placeholder="资料库选择"
                >
                  {databaseList &&
                    databaseList.map(it => {
                      return (
                        <Select.Option value={it.uuid} key={it.uuid}>
                          {it.name}
                        </Select.Option>
                      );
                    })}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`companyUuid${item.uuid}`, {
                rules: [
                  {
                    required: !!item.scan,
                    message: '请选择归属公司',
                  },
                ],
                initialValue: item.scan ? companyUuid : null,
              })(
                <CompanySearch
                  companyName={item.scan ? this.props.incubator : null}
                  onChange={(value, option) => this.handleCompanyChange(item.uuid, value, option)}
                  {...this.props}
                />,
              )}
            </FormItem>
          </Col>

          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`directoryUuid${item.uuid}`, {
                rules: [
                  {
                    required: !!item.scan,
                    message: '请选择所属目录',
                  },
                ],
              })(
                <Cascader
                  changeOnSelect
                  onChange={(value, selectedOptions) =>
                    this.onChange(item.uuid, value, selectedOptions)
                  }
                  options={item.directoryList}
                  placeholder="请选择所属目录"
                  displayRender={this.showLable}
                />,
              )}
            </FormItem>
          </Col>
          <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`materialType${item.uuid}`, {
                rules: [
                  {
                    required: !!item.scan,
                    message: '请选择所属类型',
                  },
                ],
                initialValue: item.scan && defaultTypeName ? defaultTypeName : null,
              })(
                <Select style={{ width: '100%' }} placeholder="所属类型选择">
                  {item.types &&
                    item.types.map(it => {
                      return (
                        <Select.Option value={it.name} key={it.name}>
                          {it.name}
                        </Select.Option>
                      );
                    })}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`returnCount${item.uuid}`, {
                rules: [
                  {
                    required: !!item.scan,
                    message: '请填写归档数量',
                  },
                ],
                initialValue: item.scan ? 1 : null,
              })(<InputNumber placeholder="请填写归档数量" style={{ width: '90%' }} />)}
            </FormItem>
          </Col>
          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`returnDate${item.uuid}`, {
                rules: [
                  {
                    required: !!item.scan,
                    message: '请填写实际归档时间',
                  },
                ],
                initialValue: item.scan ? moment(Date.now()) : null,
              })(<DatePicker />)}
            </FormItem>
          </Col>
          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem style={{ margin: 0, height: '60px', paddingTop: '4px' }}>
              {getFieldDecorator(`scan${item.uuid}`, {
                initialValue: item.scan ? [item.scan] : [],
              })(
                <UploadFile
                  limit={1}
                  type="ghost"
                  isPreview
                  style={{ width: '60%' }}
                  onChange={file => this.onUploadFileChange(item, file)}
                  onRemove={file => this.fileRemove(item, file)}
                />,
              )}
            </FormItem>
          </Col>
        </Row>
      </div>
    );
  };

  emptyInfo = () => {
    const _this = this;
    Modal.confirm({
      icon: <Icon type="login" />,
      title: '没有需要归档的文件,点击确定直接通过',
      onOk() {
        _this.handleOk();
      },
      onCancel() {
        _this.props.handleCancel(false);
      },
    });
  };

  render() {
    const { visible, handleCancel, confirmLoading } = this.props;
    const { returnEffect } = this.state;
    if (returnEffect.length) {
      return (
        <Modal
          title="行政文件归档"
          visible={visible}
          okText="通过"
          onOk={this.handleOk}
          confirmLoading={confirmLoading}
          onCancel={() => handleCancel(false)}
          width="95%"
        >
          <Row>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              附件
            </Col>
            <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              文件编号
            </Col>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              归属资料库
            </Col>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              归属公司
            </Col>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              归属目录
            </Col>
            <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              归属类型
            </Col>
            <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              归档数量
            </Col>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              实际归档时间
            </Col>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              上传扫描件
            </Col>
          </Row>
          <Form>
            {returnEffect.map(item => {
              return this.effectItem(item);
            })}
          </Form>
        </Modal>
      );
    }
    return <div>{visible ? this.emptyInfo() : null}</div>;
  }
}

export default Form.create()(ModalAccount);



// WEBPACK FOOTER //
// ./src/components/comm/workflow/incubatorScan/ModalArchiveUpload.js